import { Form, Input } from 'antd';

export const PriceField = () => {
  return (
    <Form.Item name='contribution' label='Взнос'>
      <Input placeholder='1 200' size='large' />
    </Form.Item>
  );
};
